/* One subject: a row per year.
   OWNED BY ITEM 4 OF docs/plan/00-prestavba-2026-08.md.

   The subject is the series and the year is the season — which is not a
   metaphor here but the shape of the thing: a teacher has one subject and one
   year, and everything else on the page is somebody else's lesson. */

import { Link, useParams } from "react-router-dom";
import { covers } from "../../lib/covers";
import { useI18n } from "../../lib/i18n";
import { usePortal } from "../../lib/portal";
import { useIndex, itemsIn, yearsIn } from "../../lib/hooks";
import { Billboard, Crumbs, Row, Tile } from "./Tile";
import { NotFound } from "../NotFound";
import { plural } from "./plural";
import { TileFoot, tileSub } from "./entry";

export function SubjectPage() {
  const { strand = "", subject = "" } = useParams();
  const { t, ui, href } = useI18n();
  const { taxonomy } = usePortal();
  const { data: index } = useIndex();
  if (!taxonomy) return null;

  const s = taxonomy.strands[strand], sub = taxonomy.subjects[subject];
  if (!s || !sub) return <NotFound />;

  const years = index ? yearsIn(index, strand, subject, s.years) : [];
  /* The branch every tile on this page is being seen in: it decides the palette
     of the column and, with the strand's span of years, the density. */
  const branch = { strand, years: s.years };

  return (
    <div className="catalog">
      <Crumbs parts={[
        { label: ui("nav.home"), to: href("/") },
        { label: t(s.short), to: href(`/s/${strand}`) },
        { label: t(sub.name) },
      ]} />
      <Billboard art={covers.subject(subject, branch, taxonomy.subjects)}
                 eyebrow={t(s.name)} title={t(sub.name)}
                 lead={years.length ? ui("subject.lead") : ui("subject.empty")} />
      {years.map(({ year, count }) => (
        <Row key={year} title={
          <Link className="cat-row-link" to={href(`/s/${strand}/${subject}/${year}`)}>
            {year}. {ui("year.suffix")}
          </Link>
        } count={plural(count, ui)}>
          {itemsIn(index ?? [], strand, subject, year).map((e) => (
            <Tile key={e.id} to={href(`/m/${e.id}`)} art={covers.material(e, branch)}
                  title={e.title} sub={tileSub(e)} foot={<TileFoot entry={e} />} />
          ))}
        </Row>
      ))}
    </div>
  );
}
